module.exports = __webpack_public_path__ + "img/resource-zn-active.3c9bd867.png";